import React from "react";
import { Popup, Cell, Button, Picker, Toast } from "zarm";
import ReactEcharts from "echarts-for-react";
import moment from "moment";
import Table from "./table";

const defaultList = {
  list: [
    {
      examOdContent: "33.33 mm",
      examOsContent: "22.22 mm",
      examContent: "OD: 33.33 mm  OS: 22.22 mm",
      examDate: "1681056000",
      examFiles: [],
    },
    {
        examOdContent: "47.33 mm",
        examOsContent: "74.22 mm",
        examContent: "OD: 33.33 mm  OS: 22.22 mm",
        examDate: "1681228800",
        examFiles: [],
      },
    
    {
      examOdContent: "43.33 mm",
      examOsContent: "32.22 mm",
      examContent: "OD: 33.33 mm  OS: 22.22 mm",
      examDate: "1681401600",
      examFiles: [],
    },
     {
      examOdContent: "67.33 mm",
      examOsContent: "56.22 mm",
      examContent: "OD: 33.33 mm  OS: 22.22 mm",
      examDate: "1681660800",
      examFiles: [],
    },
    // {
    //   examOdContent: "67.33 mm",
    //   examOsContent: "56.22 mm",
    //   examContent: "OD: 33.33 mm  OS: 22.22 mm",
    //   examDate: "1682265600",
    //   examFiles: [],
    // },
    // 上面的是同一个月
    
    // {
    //   examOdContent: "43.33 mm",
    //   examOsContent: "52.22 mm",
    //   examContent: "OD: 33.33 mm  OS: 22.22 mm",
    //   examDate: "1687968000",
    //   examFiles: [],
    // },
    // {
    //   examOdContent: "13.33 mm",
    //   examOsContent: "82.22 mm",
    //   examContent: "OD: 33.33 mm  OS: 22.22 mm",
    //   examDate: "1685289600",
    //   examFiles: [],
    // },

    // {
    //   examOdContent: "43.33 mm",
    //   examOsContent: "27.22 mm",
    //   examContent: "OD: 33.33 mm  OS: 22.22 mm",
    //   examDate: "1660233600",
    //   examFiles: [],
    // },
    // {
    //   examOdContent: "22.34 mm",
    //   examOsContent: "76.48 mm",
    //   examContent: "OD: 12.34 mm  OS: 56.48 mm",
    //   examDate: "1691769600",
    // },
    // {
    //   examOdContent: "82.34 mm",
    //   examOsContent: "96.48 mm",
    //   examContent: "OD: 12.34 mm  OS: 56.48 mm",
    //   examDate: "1668182400",
    // },
    // {
    //   examOdContent: "82.34 mm",
    //   examOsContent: "96.48 mm",
    //   examContent: "OD: 12.34 mm  OS: 56.48 mm",
    //   examDate: "1683820800",
    // },
    // {
    //   examOdContent: "82.34 mm",
    //   examOsContent: "96.48 mm",
    //   examContent: "OD: 12.34 mm  OS: 56.48 mm",
    //   examDate: "1689091200",
    // },
    //  {
    //   examOdContent: "82.34 mm",
    //   examOsContent: "96.48 mm",
    //   examContent: "OD: 12.34 mm  OS: 56.48 mm",
    //   examDate: "1697040000",
    // },
    
    // {
    //   examOdContent: "82.34 mm",
    //   examOsContent: "96.48 mm",
    //   examContent: "OD: 12.34 mm  OS: 56.48 mm",
    //   examDate: "1702310400",
    // },
  ],
};

class TableEcharts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      option: {}, // 表格的数据
    };
  }
  columns = [
    {
      title: "时间",
      dataIndex: "examDate",
      key: "examDate",
    },
    {
      title: "OD",
      dataIndex: "examOdContent",
      key: "examOdContent",
    },
    {
      title: "OS",
      dataIndex: "examOsContent",
      key: "examOsContent",
    },
  ];

  componentDidMount() {
    const { data } = this.props;
    const { examCode, noEcharts } = data;
    let callback = () => {};
    if (examCode === "85009") {
      // 裸眼视力
      callback = (item) => {
        let number = item.split("(")[0];
        if (number.indexOf("<") > -1) {
          number = number.split("<")[1];
        }
        return number;
      };
    } else if (examCode === "85017") {
      // 眼轴
      callback = (item) => item.replace(/ mm/g, "");
    }
    // noEcharts为true时，不展示折线图；
    // 处理表格的数据
    !noEcharts && this.handleEcartsData(callback);
  }

  /**
   * 处理表格的数据
   */
  handleEcartsData = (callback) => {
    const { data = {} } = this.props;
    const { examCode } = data;
    let { list: initList = [] } = data;
    // let { list: initList = [] } = defaultList;
    let list = [];
    // 过滤掉相同日期的数据。取最新的一条
    initList.forEach((item) => {
      const isExit = list.find((i) => i.examDate === item.examDate);
      if (!isExit) {
        list.unshift(item);
      }
    });
    // 数据按日期从小到大排序；
    list = list.sort((a, b) => {
      if (+a.examDate > b.examDate) {
        // a b 分别是Arr中的 56 21
        return 1; //返回正数 ，b排列在a之前
      } else {
        return -1; //返回负数 ，a排列在b之前
      }
    });
    console.log("list", list);
    // 设置x轴的值
    // 日期数据列表的集合
    const dateList = list.map((item) => item.examDate * 1000);
    // const xAxisList = dateList.map(item => moment(item).format('YY/MM'))
    // console.log('xAxisList', xAxisList);
    let maxDate = Math.max(...dateList); // x轴显示的最大值
    let minDate = +Math.min(...dateList); // x轴显示的最小值
    let formatter = "{yy}/{MM}"; // x周显示的形式
    let unit = '年/月';
    const diffMonths = moment(maxDate).diff(moment(minDate), "months"); // 最大值与最小值之间的月份差值
    const diffDays = moment(maxDate).diff(moment(minDate), "days"); // 最大值与最小值之间的天数差值
    // if (diffMonths === 0 && diffDays < 5) { // 差距少于一个月且
    // //   formatter = "{MM}/{dd}";
    // //    // 差距小于5个月
    // //    const splitNumber = Math.ceil((4 - diffDays) / 2);
    // //    minDate = moment(minDate).subtract(splitNumber, "days");
    // //    maxDate = moment(maxDate).add(splitNumber, "days");
    // //    minDate = minDate.unix() * 1000; // 最小值
    // //    maxDate = maxDate.unix() * 1000; // 最大值
    // } else 
    if (diffMonths === 0) {// 差距少于一个月
        formatter = "{MM}/{dd}";
        unit = '月/日';
        const sub = diffDays % 4;
        // minDate = moment(minDate).subtract(splitNumber, "days");
        maxDate = moment(maxDate).add(sub, "days").unix() * 1000;
        // minDate = minDate.unix() * 1000; // 最小值
        // maxDate = maxDate.unix() * 1000; // 最大值
    } else if (diffMonths > 0 && diffMonths < 5) {
      // 差距小于5个月
      const splitNumber = Math.floor((4 - diffMonths) / 2);
      minDate = moment(minDate).subtract(splitNumber, "months");
      maxDate = moment(maxDate).add(splitNumber, "month");
      minDate = minDate.unix() * 1000; // 最小值
      maxDate = maxDate.unix() * 1000; // 最大值
    }
    // else if (diffMonths > 5) {
    //     const splitNumber = diffMonths % 4;
    //     maxDate = moment(maxDate).add(splitNumber, "month");
    //     minDate = moment(minDate).subtract(splitNumber, "months");
    //     maxDate = maxDate.unix() * 1000; // 最大值
    //     minDate = minDate.unix() * 1000; // 最小值
    // }
    console.log(
      maxDate,
      "maxDate",
      "minDate",
      minDate,
      "diffMonths",
      diffMonths,
      "diffDays",
      diffDays
    );

    // od数据列表的集合
    const odDataList = list.map((item) => {
      return item.examOdContent ? +callback(item.examOdContent) : '';
    }).filter(item => item);
    // os数据列表的集合
    const osDataList = list.map((item) => {
      return item.examOsContent ? +callback(item.examOsContent) : '';
    }).filter(item => item);
    const yAxisList = [...odDataList, ...osDataList];
    // 设置y轴分段
    let yInterval = 0.5;
    let yMaxNum = 0;
    let yMinNum = 0;
    if (yAxisList.length) {
      // 取数据中最大值,最小值
      const yMax = Math.max(...yAxisList);
      yMinNum = Math.min(...yAxisList);
      // 设置整除3的相近值
      if (yMax < 0) {
        yMaxNum = 0;
      } else {
        yMaxNum = yMax;
        // yMaxNum = Math.abs(yMax % 4) === 0 ? yMax : (Math.floor(yMax / 4) + 1) * 3;
      }
      yMinNum = Math.min(...yAxisList);
      // 7等分 设置y轴最大、最小值 最小值取数据最小在减去一等分,最大值同理
      yInterval =
        yMaxNum - yMinNum <= 0.1
          ? Number(yMaxNum - yMinNum)
          : Number((yMaxNum - yMinNum) / 4);
      yInterval = +yInterval.toFixed(2);

      if (examCode === "85009") {
        yInterval = yInterval < 0.1 ? 0.1 : yInterval;
        yInterval = +yInterval.toFixed(1)
      }
      yMinNum -= yInterval;
      if (yMinNum < 0) {
        yMinNum = 0;
      }
      yMaxNum = yInterval * 6 + yMinNum;
      // console.log('yMinNum', yMinNum, 'yMaxNum', yMaxNum, 'yInterval', yInterval, 'odDataList', odDataList, 'osDataList', osDataList)
    }

    // od 折线series数据列表的集合
    const seriesODataList = list.map((item) => {
      const value = item.examOdContent ? +callback(item.examOdContent) : null; // od值
      const key = moment(+item.examDate * 1000).format("YYYY/MM/DD"); // 日期
      return [key, value];
    });
    // os 折线series数据列表的集合
    const seriesOSataList = list.map((item) => {
      const value = item.examOsContent ? +callback(item.examOsContent) : null; // os值
      const key = moment(+item.examDate * 1000).format("YYYY/MM/DD"); // 日期
      return [key, value];
    });
    console.log(
      "seriesODataList",
      seriesOSataList,
      "seriesODataList",
      seriesOSataList,
      "xAxis",
      dateList
    );
    // 表格图表
    const option = {
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: ["OD", "OS"],
      },
      grid: {
        left: "6%",
        right: "6%",
        bottom: "6%",
        containLabel: true,
      },
      xAxis: {
        name: `单位：${unit}`,
        nameLocation: 'middle',
        nameTextStyle: {
            padding: [10, 0, 0, 0]
          },
        type: "time",
        max: maxDate, // 最大值
        min: minDate,
        splitNumber: 4, // 间隔
        axisLabel: {
          formatter,
        },
        // data: xAxisList,
        align: "center",
        boundaryGap: true,
        axisTick: {
          alignWithLabel: true,
        //   interval: 0,
        }
      },
      // yAxis: {
      //     type: 'value'
      // },
      yAxis: {
        // name: 'mm',
        type: "value",
        boundaryGap: false,
        axisLabel: {
          formatter(value) {
            return value.toFixed(examCode === "85009" ? 1 : 2);
          },
        },
        max: yMaxNum.toFixed(2), // 最大值
        min: yMinNum.toFixed(2), // 最小值
        interval: yInterval, // 间隔
      },
      color: ["#00a185", "#00a6ff"],
      series: [
        {
          name: "OD",
          type: "line",
          data: seriesODataList,
          connectNulls: true, // 解决断点问题
        },
        {
          name: "OS",
          type: "line",
          data: seriesOSataList,
          connectNulls: true, // 解决断点问题
        },
      ],
    };
    this.setState({ option });
  };

  render() {
    const { option = {} } = this.state;
    const { data = {} } = this.props;
    const { list = [], noEcharts } = data;
    return (
      <>
        {!noEcharts && (
          <ReactEcharts style={{ height: "260px" }} option={option} />
        )}
        {<Table dataSource={list} columns={this.columns} />}
      </>
    );
  }
}

export default TableEcharts;
